<div class="echarts" echarts [options]="chartOption" style="height: 250px;"></div>